import React, {
  memo, useRef, useCallback,
} from 'react'
import Form, { FormConsumer } from '@active/react-ui/Form'
import FormGroup from '@active/react-ui/FormGroup'
import FormLabel from '@active/react-ui/FormLabel'
import FormField from '@active/react-ui/FormField'
import Modal from '@active/react-ui/Modal'
import ModalBody from '@active/react-ui/ModalBody'
import ModalFooter from '@active/react-ui/ModalFooter'
import Grid from '@active/react-ui/Grid'
import GridItem from '@active/react-ui/GridItem'
import IntlPhoneInput from '@active/react-ui/IntlPhoneInput'
import PopperController from '@active/react-ui/PopperController'
import Button from '@active/react-ui/Button'
import {
  func, string,
} from 'prop-types'
import { Locale, withI18n } from '@active/react-utils/i18n'
import isEmpty from 'lodash/isEmpty'
import classNames from 'classnames'
import { useCommonContext } from '../../../../widgets/widgetCommonContext'
import './VerifyPhoneStepOne.scss'

function VerifyPhoneStepOne({
  phoneNumber,
  title,
  rejectButtonText,
  handleClose,
  handleReject,
  handleConfirm,
  i18n,
  defaultLocale,
  ...rest
},
) {
  const okText = 'passport.common.btn.sendCode'
  const phoneInputLabel = 'passport.user.userProfile.phoneNumber'
  const phoneInputPlaceHolder = i18n('passport.user.userProfile.phoneNumber')
  const desc = i18n('passport.phoneAuthentication.modal.description.addPhoneNumber')

  const formRef = useRef()
  const {
    intlPhonePopperControls: {
      zIndex, className, ...restPopperControls
    } = {},
  } = useCommonContext()

  const handleSubmit = useCallback(async () => {
    const result = await formRef.current.validateForm({ shouldTouchFields: true })
    if (isEmpty(result)) {
      handleConfirm({
        ...formRef.current.values,
      })
    }
  }, [handleConfirm, formRef])

  return (
    <Modal
      title={i18n(title)}
      onClose={handleClose}
      size="md"
      shown
      {...rest}
      className="phone-verify-step-one"
    >
      <ModalBody className="modal-body phone-verify-step-one-content">
        <div>
          {desc}
        </div>
        <PopperController
          zIndex={zIndex || 'layer-5'}
          className={classNames(className, 'max-menu-h-250')}
          {...restPopperControls}
        >
          <Form
            initialValues={{
              phoneNumber,
            }}
          >
            <Grid fluid rowGap={0} colGap={0}>
              <GridItem span={12} spanMd={8}>
                <FormGroup name="phoneNumber" withoutLayout required>
                  <FormLabel verticalStart><Locale id={phoneInputLabel} /></FormLabel>
                  <FormField defaultLocale={defaultLocale} as={IntlPhoneInput} placeholder={phoneInputPlaceHolder} />
                </FormGroup>
              </GridItem>
            </Grid>
            <FormConsumer>
              {
              ({
                form,
              }) => {
                formRef.current = form
              }
            }
            </FormConsumer>
          </Form>
        </PopperController>
      </ModalBody>
      <ModalFooter>
        <Button
          type="strong"
          onClick={handleSubmit}
        >
          <Locale id={okText} />
        </Button>
        <Button
          type="secondary"
          onClick={handleReject}
        >
          <Locale id={rejectButtonText} />
        </Button>
      </ModalFooter>
    </Modal>

  )
}

VerifyPhoneStepOne.propTypes = {
  handleConfirm: func.isRequired,
  handleReject: func.isRequired,
  handleClose: func.isRequired,
  i18n: func.isRequired,
  title: string.isRequired,
  rejectButtonText: string.isRequired,
  phoneNumber: string,
  defaultLocale: string,
}

VerifyPhoneStepOne.defaultProps = {
  phoneNumber: '',
  defaultLocale: 'en_US',
}
export default memo(withI18n(VerifyPhoneStepOne))
